
export const getSwapedKeysAndValues = (obj:any) => {
  const res:any = {};

  Object.keys(obj).forEach(function(value) {
    var key = obj[value];
    res[key] = value;
  });
  return res;
};